import RichText from "@/components/RichText";
import { CoverImage } from "../components/Primitives";
import { BODY_DARK, CONTAINER, DARK_BG, OVERLAY_CENTER } from "../tokens";

// Bande citation centrée (min 360px) : photo des bobines (opacité .45) +
// voile .62, H2 « Redonner une seconde vie aux vêtements » et deux
// paragraphes, max-width 760px.
export default function QuoteBandSection({ props = {} }) {
  return (
    <section className="relative min-h-[360px] flex items-center justify-center text-center overflow-hidden" style={DARK_BG}>
      <CoverImage src={props.image_url} alt={props.alt} opacity={0.45} />
      <div className="absolute inset-0" style={{ background: OVERLAY_CENTER }} aria-hidden="true" />
      <div className={`${CONTAINER} relative flex justify-center`}>
      <div className="px-5 md:px-11 py-[72px] max-w-[760px]">
        <RichText
          as="h2"
          className="block font-display font-light text-[clamp(26px,3.4vw,40px)] leading-[1.18] text-cream mb-[26px] [text-wrap:balance]"
          html={props.heading}
        />
        <RichText as="div" preserveParagraphs className={`${BODY_DARK} [&_p]:mb-[18px] [&_p:last-child]:mb-0`} html={props.body} />
      </div>
      </div>
    </section>
  );
}
